module.exports = __webpack_public_path__ + "static/media/instagram.449d417f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram.svg
// module id = 195
// module chunks = 0